import { render, staticRenderFns } from "./DataTableResultado.vue?vue&type=template&id=488c8902"
import script from "./DataTableResultado.vue?vue&type=script&lang=js"
export * from "./DataTableResultado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports